import { render } from "./ViewDatailsOsContract.vue?vue&type=template&id=059d26fe&scoped=true"
import script from "./ViewDatailsOsContract.vue?vue&type=script&lang=js"
export * from "./ViewDatailsOsContract.vue?vue&type=script&lang=js"

import "./ViewDatailsOsContract.vue?vue&type=style&index=0&id=059d26fe&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059d26fe"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QList from 'quasar/src/components/item/QList.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QList,QExpansionItem,QCard,QCardSection});
